import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacity,
    KeyboardAvoidingView,
    ImageBackground, Alert, Image, I18nManager, ActivityIndicator, RefreshControl,

    TouchableHighlight,
    Text
} from "react-native";
// import { Modal } from 'react-native-paper';

import {connect} from "react-redux";


import {scale, moderateScale, verticalScale} from '../../../tools/Scaling';

import Colors from "../../../tools/Colors";


//import HMActionBarSatia from "../../../customviews/HMActionBarSatia";
import {AsyngStorageClass} from "../../../tools/AsyngStorageClass";
import {
    callWebservice as callWebserviceSplash,
    serviceActionRtl
} from "../../../screens/satia/splash/action/ActionSplashSatiaScreen";

const {width: SCREEN_WIDTH} = Dimensions.get("window");
const SLIDER_HEIGHT = verticalScale(180);
const HEADER_HEIGHT = Platform.OS === "ios" ? verticalScale(64) : verticalScale(50);
const SCROLL_HEIGHT = SLIDER_HEIGHT - HEADER_HEIGHT;
const THEME_COLOR = Colors.colorPrimary;
import i18n from '../../../I18n/i18n.js';
/*//import HMImageBackground from "../../customviews/HMImageBackground";
//import HMListDiffSize from "../../customviews/HMListDiffSize";
import Carousel, {Pagination, ParallaxImage} from 'react-native-snap-carousel';
//import SliderEntry from "../../customviews/SliderEntry";
import styles from "../../../styles/index.style";
import {itemWidth, sliderWidth} from "../../../styles/SliderEntry.style";*/

const IS_ANDROID = Platform.OS === 'android';
const SLIDER_1_FIRST_ITEM = 0;
let content = null
//import {DialogUpdateAppCustomize} from "../../../customviews/DialogUpdateAppCustomize";
import moment from "moment-jalaali";
//import fa from "moment/src/locale/fa";
import store from "../../../redux/store";
import {typeExport} from "../../../redux/store/type";
import HMTextView from "../../../customviews/HMTextView";
//import HMImageView from "../../../customviews/HMImageView";
import * as NavigationService from "../../../redux/NavigationService";
import HMListDiffSizeSatia from "../../../customviews/HMListDiffSizeSatia";
import {Tools} from "../../../tools/Tools";
import DialogLoadingCustomize from "../../../customviews/DialogLoadingCustomize";
import axios from "axios";

//import Modal from "react-native-modal";
// let Modal = null;

import HMIcon from "../../../customviews/HMIcon";
import HMActionBarSatia from "../../../customviews/HMActionBarSatia";
import HMModal from "../../../customviews/modal/HMModal";
import HMAlert from "../../../customviews/HMAlert";
import HMSwiper from "../../../customviews/swiper/HMSwiper";
import {DynamicContentSlide} from "../../../customviews/swiper/DynamicContentSlide";
import {DialogUpdateAppCustomize} from "../../../customviews/dialogUpdateApp/DialogUpdateAppCustomize";
// import HMBottomSheet from "../../../customviews/bottomSheet/HMBottomSheet";
// import HMBottomSheetModal from "../../../customviews/bottomSheet/HMBottomSheetModal";
// import BottomSheet from "@gorhom/bottom-sheet/lib/typescript/components/bottomSheet/BottomSheet";
//import BottomSheet from '@gorhom/bottom-sheet';

// moment.locale("fa", fa);
// moment.loadPersian();

class MainSatiaScreen extends Component {

    wp(percentage, viewportWidth) {
        const value = (percentage * viewportWidth) / 100;
        return Math.round(value);
    }

    constructor(props) {
        super(props);
        content = this;
        //  Modal = require(Platform.OS === "web" ? "modal-react-native-web" : "react-native-modal");

        let Services = this.props.DataSplashSatiaScreen.user.customer && this.props.DataSplashSatiaScreen.user.customer.services ? this.props.DataSplashSatiaScreen.user.customer.services : [];
        let listServiceP = [];
        let listServiceA = [];
        let listServiceN = [];
        let listOthers = [];
        Services = Services ? Services : [];
        for (let i = 0; i < Services.length; i++) {
            //
            let f = Services[i].Active;

            if (f == 0)
                listServiceP.push(Services[i])

            else if (f == 1)
                listServiceA.push(Services[i])

            else if (f == 2)
                listServiceN.push(Services[i])
            else {
                listOthers.push(Services[i])
            }

        }

        // let myService = null;
        // let listGroup = this.props.DataSplashSatiaScreen.results.listGroup;
        // listGroup = listGroup ? listGroup : [];
        // let finalMyService = null;
        // myService = Services.find(obj => obj.Active == 1)
        // if (myService) {
        //     let group = listGroup.find(obj => obj.ServiceGroup == myService.ServiceGroup)
        //     if (group) {
        //         let service = group.services.find(obj => obj.Speed == myService.SpeedClass)
        //         if (service) {
        //             finalMyService = service.list.find(obj => obj.Serial == myService.Serial)
        //         }
        //     }
        //     else {
        //         finalMyService = myService
        //     }
        // }
        let sliderWidth = 1;
        let itemWidth = 1;
        let slideHeight = 1;
        let widthOriginal = Platform.OS === "web" ? 1 : typeExport._WIDTH;

        if (Platform.OS === "web") {
            let viewportWidth = document.body.clientWidth;
            let viewportHeight = document.body.clientHeight;
            widthOriginal = document.body.clientWidth;

            slideHeight = viewportHeight * 0.35;
            const slideWidth = this.wp(75, viewportWidth);
            const itemHorizontalMargin = this.wp(2, viewportWidth);

            sliderWidth = viewportWidth;
            itemWidth = (slideWidth + itemHorizontalMargin * 2) + 55;
        }
        this.state = {
            widthOriginal: widthOriginal,

            itemWidth: itemWidth,
            sliderWidth: sliderWidth,
            slideHeight: slideHeight,


            visibleModal: false,
            selectAccount: null,

            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,


            modalHeight: 0,
            ddd: [
                "The min size must be a number.",
                "The min size must be less than 4.",
                "The max size must be a number."
            ],
            //  entries: props.DataSplashSatiaScreen.results.slider

            ServicesP: listServiceP && listServiceP.length > 0 ? listServiceP[0] : null,
            ServicesA: listServiceA && listServiceA.length > 0 ? listServiceA[0] : null,
            ServicesReserve: listServiceN && listServiceN.length > 0 ? listServiceN[0] : null,
            //   myService: myService && ListService ? ListService.find(obj => obj.Serial == myService.Serial) : null,
            myService: listServiceA && listServiceA.length > 0 ? listServiceA[0] : null,

        };

        this.props.navigation.addListener('focus', () => {


                if (global._refreshSplashSatia) {
                    global._refreshSplashSatia = false;
                    // let dataSplash = this.props.DataSplashSatiaScreen
                    //
                    // let paramss = {
                    //     "token": dataSplash.token,
                    //     "id": 1,
                    //     "lang": i18n.locale,
                    //     "imei": 0,
                    //     "token_fb": dataSplash.token_fb,
                    // };
                    // store.dispatch(callWebserviceSplash(Constants.urlGetSatia, paramss, Constants.TypeGetAllData, Constants._GET, dataSplash.token, dataSplash.token_fb, null, "MainScreen"))
                    this.getDataServerSplash()
                }
            }
        )
        this.props.navigation.addListener('blur', () => {
            }
        )
        /*       let startTime = new Date().getTime();
               let speeds = [];
               let duration = null
               RNFS.downloadFile({
                   fromUrl: "https://prd-wret.s3.us-west-2.amazonaws.com/assets/palladium/production/s3fs-public/thumbnails/image/test-5mb.png",
                   toFile: `${RNFS.DocumentDirectoryPath}/test.jpg`,
                   //headers
                   background: true,// **!// Continue the download in the background after the app terminates (iOS only)**
                   discretionary: true, //!**!// Allow the OS to control the timing and speed of the download to improve perceived performance  (iOS only)**
                   cacheable: true, //!**!// Whether the download can be stored in the shared NSURLCache (iOS only, defaults to true)**

                   begin: (res: DownloadBeginCallbackResult) => {
                   },
                   progress: (res: DownloadProgressCallbackResult) => {
                       let progressPercent = (res.bytesWritten / res.contentLength) * 100; // to calculate in percentage
                       this.setState({progress: progressPercent.toString()});
                       //      item.downloadProgress = progressPercent;


                       //here you can calculate your progress for file download
                       let currentTime = new Date().getTime();
                       duration = (currentTime - startTime) / 1000;
                       let speed11 = ((res.bytesWritten * 8) / (1024 ** 2 * duration));
                       let speed = ((res.bytesWritten) / (duration));

                       speeds.push(speed);
                       Tools.getSizeByte(speed)
                       this.setState({downloadSpeed: speed})


                   }
               })
                   .promise.then(res => {
                   let finalSpeed = (speeds.reduce((total, value) => total + value)) / speeds.length;

                   //return RNFS.readFile(downloadfilePath, "base64");
               })*/

        if (Platform.OS === "web") {
            /*      window.onbeforeunload = function () {
                      return false;
                  }*/
            window.beforeinstallprompt = function () {
                return false;
            }
        }


        /*        window.addEventListener("beforeunload", function(event) { alert("xkvjxhv")});
                window.addEventListener("beforeinstallprompt", ev => {
                    // Stop Chrome from asking _now_
                    ev.preventDefault();
                    alert("vbnvbdfdf")
                    // Create your custom "add to home screen" button here if needed.
                    // Keep in mind that this event may be called multiple times,
                    // so avoid creating multiple buttons!
                    //   myCustomButton.onclick = () => ev.prompt();
                });*/
    }


    componentWillReceiveProps(props) {

        if (props.DataSplashSatiaScreen.user && props.DataSplashSatiaScreen.user.customer) {
            let Services = props.DataSplashSatiaScreen.user.customer && props.DataSplashSatiaScreen.user.customer.services ? props.DataSplashSatiaScreen.user.customer.services : [];
            let listServiceP = [];
            let listServiceA = [];
            let listServiceN = [];
            let listOthers = [];
            Services = Services ? Services : [];

            for (let i = 0; i < Services.length; i++) {
                //
                let f = Services[i].Active;

                if (f == 0)
                    listServiceP.push(Services[i])

                else if (f == 1)
                    listServiceA.push(Services[i])

                else if (f == 2)
                    listServiceN.push(Services[i])
                else {
                    listOthers.push(Services[i])
                }

            }

            this.setState(
                {
                    ServicesP: listServiceP && listServiceP.length > 0 ? listServiceP[0] : null,
                    ServicesA: listServiceA && listServiceA.length > 0 ? listServiceA[0] : null,
                    ServicesReserve: listServiceN && listServiceN.length > 0 ? listServiceN[0] : null,
                    //myService: finalMyService,
                    myService: listServiceA && listServiceA.length > 0 ? listServiceA[0] : null,

                }
            );

        }

    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true})
    }

    async componentDidMount() {

        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;

                function wp(percentage) {
                    const value = (percentage * viewportWidth) / 100;
                    return Math.round(value);
                }

                const slideHeight = viewportHeight * 0.35;
                const slideWidth = wp(75);
                const itemHorizontalMargin = wp(2);

                const sliderWidth = viewportWidth;
                const itemWidth = (slideWidth + itemHorizontalMargin * 2) + 55;

                content.setState({
                        widthOriginal: document.body.clientWidth,
                        widthV: document.body.clientWidth > 600 ? document.body.clientWidth / 2.05 : document.body.clientWidth,

                        //    widthV: document.body.clientWidth,
                        heightV: document.body.clientHeight,
                        itemWidth: itemWidth,
                        sliderWidth: sliderWidth,
                        slideHeight: slideHeight,
                    },
                )


            })

        //     await AsyngStorageClass.setAsyng("_Help", false)

        let help = await AsyngStorageClass.getASyng("_Help");
        this.setState({
            visibleModal: !help,
            help: help,
        })
        if (global._loadDataCount && global._loadDataCount > 0 || !(this.props.DataSplashSatiaScreen.results && this.props.DataSplashSatiaScreen.results.status)) {
            this.getDataSplash();
        }

        else
            global._loadDataCount = global._loadDataCount ? global._loadDataCount + 1 : 1


        //this.refRBSheet.open()
    }

    async getDataSplash() {
        this.setState({
            noShowMessage: false
        })

        let dataSplash = content.props.DataSplashSatiaScreen


        if (dataSplash.Connection) {
            //if (global.GoOfflineToMain) {
            content.getDataServerSplash()

            //   }

            // await AsyngStorageClass.setAsyng("splashSatiaWP" + global.IdCity, dataSplash.results);
            //  await AsyngStorageClass.setAsyng("splashSatia" + global.IdCity, dataSplash.results);
        }
    }

    getDataServerSplash() {
        //   let dataSplash = content.props.DataSplashSatiaScreen
        let paramss = {
            "token": content.props.token,
            "id": 1,
            "lang": i18n.locale,
            "imei": 0,
            "token_fb": content.props.token_fb,
            'Account': content.props.Account ? content.props.Account : null,
        };
        store.dispatch(callWebserviceSplash(paramss, typeExport.TypeGetAllData, typeExport._GET, "MainScreen"))
    }

    componentWillUnmount() {
        //Tools._RemoveConnectivity()
    }

    /*  static ShowMessageBack(text) {
          content.refs.toast.show(text ? text : i18n.t('constant.DescExit'), 1200, () => {
              // something you want to do at close
          });
      }
  */
    render() {
        const {slider1ActiveSlide, ServicesP, ServicesA, ServicesReserve} = this.state;
        // this.state.dataSource = this.props.data.results.slider;

        //  let {results} = this.props.DataSplashSatiaScreen;
        let {results} = this.props.DataSplashSatiaScreen;
        let FupToInternet = this.state.myService && this.state.myService.FupToInternet ? this.state.myService.FupToInternet : 4

        let user = this.props.DataSplashSatiaScreen.user;
        let {DataSplashSatiaScreen} = this.props;
        let customer = user && user.customer;
        let customers = user && user.customers;

        let item = {
            id: 1,
            locale: 'fa',
            TotalCases: 7569,
            TotalDeaths: 232,
            TotalRecovered: 2365,
            Cases: 300,
            Deaths: 50,
            Recovered: 100,
            date: "98/12/20",
            desc: [
                {
                    title: "بروزرسانی: 18 اسفند (وزارت بهداشت، درمان و آموزش پزشکی)",
                    locale: 'fa'
                },
                {
                    title: "Update: March 1st (Ministry of Health and Medical Education)",
                    locale: 'en'
                },
                {
                    title: "هەواڵى نوێ: ئازار ١ ەم (وەزارەتى تەندروستى و پەروەردەى پزيشكى)",
                    locale: 'ku'
                },
            ]
        };
        let IBSExpire = this.state.ServicesA ? this.state.ServicesA.IBSExpire : 0;
        let IBSCredit = this.state.ServicesA ? Math.round(this.state.ServicesA.IBSCredit * 100) / 100 : 0;
        return (
            <View style={{position: 'relative', flex: 1}}>

                {/*       <HMImageBackground/>*/}

                <KeyboardAvoidingView style={{width: "100%", height: "100%",}} behavior={"padding"}
                                      enabled={Platform.OS === "ios"}>


                    <HMActionBarSatia
                        profile
                        menu
                        logo
                        props={this.props} statusBarTransparent
                        text={" ساتیا " + (customer && customer.provider && customer.provider.Serial != 1 ? (" - " + customer.provider.Name) : "")}
                        //  text={i18n.t('constant.Information')}

                        headerVisibility more_menu
                        onBackPress={() => this.props.navigation.pop()}
                        // onClickProfile={() => {
                        //
                        // }}
                        onClickProfile={true}

                        LeftView={
                            <TouchableOpacity
                                style={{
                                    //   backgroundColor: Colors.red,
                                    //    marginHorizontal: moderateScale(10),
                                    width: moderateScale(24),
                                    height: moderateScale(48),

                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}

                                onPress={

                                    //  onBackPress
                                    () => {
                                        this.setState({
                                            modalVisible: true,
                                            visibleModal: true,
                                            typeModal: "help"
                                        })
                                    }
                                }
                            >
                                <HMIcon name={"ios-help-circle-outline"}
                                        style={{fontSize: moderateScale(26), color: Colors.yellow}}/>


                                {/*<HMTextView text={i18n.t('constant.Back')}*/}
                                {/*style={{paddingLeft: moderateScale(5), color: Colors.light}}/>*/}
                            </TouchableOpacity>
                        }

                    />

                    {
                        (this.props.DataSplashSatiaScreen.isLoading) ?
                            null
                            :
                            !(customer && customer.message) || this.state.noShowMessage ?
                                null
                                :
                                <View
                                    style={{
                                        width: '99%',
                                        // height: moderateScale(30),
                                        flexDirection: 'row',
                                        borderRadius: moderateScale(4),

                                        backgroundColor: customer.message && customer.message.BgColor ? customer.message.BgColor : Colors.white,
                                        margin: moderateScale(4),
                                        alignItems: 'center',
                                        alignSelf: 'center',
                                        paddingVertical: moderateScale(8),
                                        borderWidth: moderateScale(1),
                                        borderColor: Colors.colorPrimary,

                                    }}>
                                    <View style={{flex: .9, paddingHorizontal: moderateScale(4)}}>
                                        <HMTextView
                                            text={customer.message && customer.message.Text ? customer.message.Text : ""}
                                            // text={"dfhgdfgdfgdf"}
                                            type={"bold"}
                                            style={{
                                                //textAlign: "center",
                                                color: customer.message && customer.message.TxtColor ? customer.message.TxtColor : Colors.colorDarkText,
                                                fontSize: moderateScale(14)

                                            }}/>
                                    </View>
                                    <TouchableOpacity
                                        style={{
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'center',

                                            //position: 'absolute',
                                            flex: .1,
                                        }}
                                        onPress={() => {
                                            this.setState({
                                                noShowMessage: true,
                                            })
                                        }
                                        }
                                    >

                                        <HMIcon
                                            name={"ios-close-circle-outline"}
                                            style={{
                                                fontSize: moderateScale(22),
                                                // color: Colors.colorSecondPrimary,
                                                color: customer.message && customer.message.TxtColor ? customer.message.TxtColor : Colors.colorDarkText,

                                                // textAlign: "center",
                                                padding: moderateScale(4),

                                            }}
                                        />

                                    </TouchableOpacity>
                                </View>


                    }

                    {/*
                    <Image source={{uri: "https://failed.satiaisp.com/images/logo-jadid.png"}} style={{ resizeMode: 'cover', width: 1, height: 1 }}/>
*/}

                    {
                        !this.props.DataSplashSatiaScreen.isLoading && this.props.DataSplashSatiaScreen.results && !this.props.DataSplashSatiaScreen.NoInternetDialog ?
                            null
                            :
                            <View
                                style={{
                                    width: "100%",
                                    //  flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: this.props.DataSplashSatiaScreen.NoInternetDialog ? Colors.red : Colors.white,
                                    alignSelf: 'center',
                                    padding: moderateScale(6)
                                }}
                            >
                                {this.props.DataSplashSatiaScreen.NoInternetDialog ?
                                    <View
                                        style={{
                                            width: "100%",
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                            alignItems: 'center',

                                        }}>


                                        <HMTextView
                                            type={"bold"}

                                            style={[
                                                {
                                                    // position: 'absolute',
                                                    //  bottom: 0,
                                                    // height: moderateScale(44),
                                                    // width: '100%',
                                                    textAlign: "center",
                                                    color: Colors.white,
                                                    fontSize: moderateScale(11),
                                                    //  padding: moderateScale(1),

                                                    // backgroundColor: 'rgba(0,0,0,0.25)',
                                                }]}
                                            numberOfLines={2}
                                            text={"خطایی رخ داده مجددا تلاش نمایید"}
                                        />
                                        <View style={{width: moderateScale(4)}}/>
                                        <TouchableOpacity
                                            onPress={() => {
                                                this.getDataServerSplash()

                                            }}
                                            style={{
                                                // flex: .33,
                                                // width: '92%',
                                                // height: moderateScale(28),
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: Colors.yellow,
                                                borderRadius: moderateScale(6),
                                                marginHorizontal: moderateScale(2),
                                                paddingHorizontal: moderateScale(4),
                                                paddingVertical: moderateScale(2),


                                            }}>

                                            <HMTextView
                                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                text={i18n.t('constant.Update')}
                                                //  text={"ثبت و بستن تیکت"}
                                                type={"bold"}
                                                style={{
                                                    fontSize: moderateScale(10),
                                                    marginVertical: moderateScale(2),
                                                    //     marginHorizontal: moderateScale(4),
                                                    color: Colors.white
                                                }}/>
                                        </TouchableOpacity>

                                    </View>
                                    :

                                    <View
                                        style={{
                                            width: "100%",
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                            alignItems: 'center',

                                        }}>


                                        <HMTextView
                                            type={"bold"}

                                            style={[
                                                {
                                                    // position: 'absolute',
                                                    //  bottom: 0,
                                                    // height: moderateScale(44),
                                                    // width: '100%',
                                                    textAlign: "center",
                                                    color: Colors.colorDark,
                                                    fontSize: moderateScale(11),
                                                    //  padding: moderateScale(1),

                                                    // backgroundColor: 'rgba(0,0,0,0.25)',
                                                }]}
                                            numberOfLines={2}
                                            text={i18n.t('constant.Update')}
                                        />
                                        <View style={{width: moderateScale(4)}}/>
                                        <ActivityIndicator color={Colors.colorPrimary} size={"small"}/>

                                    </View>
                                }
                            </View>


                    }
                    {
                        customer && customers ?
                            <ScrollView
                                scrollEnabled={true}

                                refreshControl={
                                    <RefreshControl refreshing={this.props.DataSplashSatiaScreen.isLoading}
                                                    onRefresh={() => this.getDataServerSplash()}/>
                                }

                            >
                                <View style={{}}>
                                    {/*           <input type="file" accept="image/*" capture="camera" />
*/}
                                    {
                                        results && results.slider && results.slider.length > 0 ?
                                            <View
                                                style={{
                                                    width: '100%',

                                                    height: ((this.state.widthOriginal > 600) ? 500 : (Platform.OS === "web" ? this.state.widthOriginal : typeExport.WIDTH)) / (results.info.heightSlider ? results.info.heightSlider : 1.6)
                                                }}>
                                                <HMSwiper

                                                    list={results.slider}
                                                    renderItem={() =>
                                                        results.slider.map((itemSwiper, indexSwiper) => {
                                                            return <DynamicContentSlide
                                                                itemSwiper={itemSwiper}
                                                                indexSwiper={indexSwiper}


                                                                onPress={() => {
                                                                    let item = itemSwiper;

                                                                    Tools.switchGoScreenSatia(item)


                                                                }}
                                                            />
                                                        })
                                                    }
                                                />
                                            </View>
                                            :
                                            null

                                    }
                                    {
                                        1 === 1 ?
                                            <View style={{width:"100%"}}>
                                            <TouchableOpacity
                                                disabled={!(customers && customers.length > 1)}
                                                onPress={() => {
                                                    this.props.navigation.navigate("ListAccountSatiaScreen", {list: customers})
                                                }}
                                                style={{
                                                    width: '95%',
                                                    height: moderateScale(40),
                                                    flexDirection: 'row',
                                                    backgroundColor: Colors.white,
                                                    alignSelf: 'center',
                                                    marginTop: moderateScale(6),
                                                    borderRadius: moderateScale(4),
                                                    overflow: 'hidden',
                                                    justifyContent: 'space-between',
                                                    paddingHorizontal: moderateScale(8)
                                                }}>
                                                <View style={{
                                                    flexDirection: 'row',
                                                    //  backgroundColor:'#ee414b',
                                                    flex: .33,
                                                    // justifyContent: 'center',
                                                    alignItems: 'center',
                                                }}>
                                                    <HMIcon
                                                        name={"user-o"}
                                                        type={"FontAwesome"}
                                                        style={{
                                                            fontSize: moderateScale(22),
                                                            // color: Colors.colorSecondPrimary,
                                                            color: Colors.colorDark,

                                                            // textAlign: "center",
                                                            padding: moderateScale(4),

                                                        }}
                                                    />
                                                    <HMTextView
                                                        type={"bold"}

                                                        style={[
                                                            {
                                                                // position: 'absolute',
                                                                //  bottom: 0,
                                                                // height: moderateScale(44),
                                                                // width: '100%',
                                                                //   textAlign: "center",
                                                                color: Colors.colorDarkText,
                                                                fontSize: moderateScale(12),
                                                                marginHorizontal: moderateScale(4)
                                                                //   marginHorizontal: moderateScale(6)
                                                                //  padding: moderateScale(1),

                                                                // backgroundColor: 'rgba(0,0,0,0.25)',
                                                            }]}
                                                        numberOfLines={2}
                                                        text={this.props.DataSplashSatiaScreen.Account ? this.props.DataSplashSatiaScreen.Account.Name : ""}
                                                    />
                                                </View>
                                                <View style={{
                                                    flex: .33,
                                                    flexDirection: 'row',
                                                    // flex: .8,
                                                    //backgroundColor:'#ee414b',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                }}>
                                                    <HMIcon
                                                        name={"account-box-outline"}
                                                        type={"MaterialCommunityIcons"}
                                                        style={{
                                                            fontSize: moderateScale(24),
                                                            // color: Colors.colorSecondPrimary,
                                                            color: Colors.colorDark,

                                                            // textAlign: "center",
                                                            padding: moderateScale(4),

                                                        }}
                                                    />
                                                    <HMTextView
                                                        type={"bold"}

                                                        style={[
                                                            {
                                                                // position: 'absolute',
                                                                //  bottom: 0,
                                                                // height: moderateScale(44),
                                                                // width: '100%',
                                                                textAlign: "center",
                                                                color: Colors.colorDarkText,
                                                                fontSize: moderateScale(12),
                                                                // marginHorizontal: moderateScale(6)
                                                                //  padding: moderateScale(1),

                                                                // backgroundColor: 'rgba(0,0,0,0.25)',
                                                            }]}
                                                        numberOfLines={2}
                                                        // text={this.props.DataSplashSatiaScreen.Account ? `${this.props.DataSplashSatiaScreen.Account.AdslTel} (${this.props.DataSplashSatiaScreen.Account.Type})` : ""}
                                                        text={this.props.DataSplashSatiaScreen.Account ? this.props.DataSplashSatiaScreen.Account.AdslTel : ""}

                                                    />
                                                </View>

                                                <View style={{
                                                    flex: .33,
                                                    // flex: .2,
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    justifyContent: 'flex-end',
                                                    //backgroundColor:'#ee414b',

                                                }}>
                                                    <HMIcon
                                                        name={"router-wireless"}
                                                        type={"MaterialCommunityIcons"}
                                                        style={{
                                                            fontSize: moderateScale(24),
                                                            // color: Colors.colorSecondPrimary,
                                                            color: Colors.colorDark,

                                                            // textAlign: "center",
                                                            padding: moderateScale(4),

                                                        }}
                                                    />
                                                    <HMTextView
                                                        type={"bold"}

                                                        style={[
                                                            {
                                                                // position: 'absolute',
                                                                //  bottom: 0,
                                                                // height: moderateScale(44),
                                                                // width: '100%',
                                                                //   textAlign: "center",
                                                                color: Colors.colorDarkText,
                                                                fontSize: moderateScale(12),
                                                                marginHorizontal: moderateScale(4)
                                                                //   marginHorizontal: moderateScale(6)
                                                                //  padding: moderateScale(1),

                                                                // backgroundColor: 'rgba(0,0,0,0.25)',
                                                            }]}
                                                        numberOfLines={2}
                                                        text={this.props.DataSplashSatiaScreen.Account ? this.props.DataSplashSatiaScreen.Account.Type : ""}
                                                    />
                                                    {
                                                        customers && customers.length > 1 ?
                                                            <View
                                                                style={{flexDirection: 'row',}}
                                                            >
                                                                <HMTextView
                                                                    type={"bold"}

                                                                    style={[
                                                                        {
                                                                            // position: 'absolute',
                                                                            //  bottom: 0,
                                                                            // height: moderateScale(44),
                                                                            // width: '100%',
                                                                            //textAlign: "center",
                                                                            color: Colors.blue,
                                                                            fontSize: moderateScale(13),
                                                                            marginBottom: moderateScale(2)
                                                                            //  padding: moderateScale(1),

                                                                            // backgroundColor: 'rgba(0,0,0,0.25)',
                                                                        }]}
                                                                    numberOfLines={2}
                                                                    text={"تغییر"}
                                                                />
                                                                <HMIcon
                                                                    name={I18nManager.getConstants().isRTL ? "ios-arrow-back" : 'ios-arrow-forward'}
                                                                    style={{
                                                                        fontSize: moderateScale(14),
                                                                        color: Colors.blue,
                                                                        // textAlign: "center",
                                                                        padding: moderateScale(4),

                                                                    }}
                                                                />

                                                            </View>
                                                            : null
                                                    }
                                                </View>

                                                {/*     <HMSelectInput
                                    onValueChange={(value, index, indexParent, itemParent) => {
                                        this.setState({
                                                selectAccount: value
                                            },
                                            () => {
                                                if (value != null && value != this.state.selectAccount)
                                                    this.editFile(indexParent, itemParent, index, value);

                                            })
                                    }}
                                    error={this.state.errorSelectInput}

                                    //  requestServerRetry={container.getServerTypeDocuments}
                                    requestServer={() => {
                                    }}
                                    //  loading={this.state.isLoadingSelectInput}
                                    value={this.state.selectAccount}
                                  //  index={itemChild.index}
                                  //  indexParent={itemChild.index}
                                    //itemParent={itemChild.item}
                                    itemSelectInput={this.state.selectAccount}
                                    //  value={"ghjghhg"}
                                    // text={i18n.t('constant.AccountType')}
                                    // options={options}
                                    options={[
                                        {label:'رایانکده آپادانا (Wireless)',value:'A'},
                                        {label:'وحید قایم مقامی (Wireless)',value:'B'},
                                        {label:'وحید قایم مقامی (Wireless)',value:'C'},
                                        {label:'رایانکده آپادانا (Wireless)',value:'D'},
                                        {label:'رایانکده آپادانا (Wireless)',value:'E'},
                                        {label:'رایانکده آپادانا (Wireless)',value:'F'},
                                        {label:'رایانکده آپادانا (Wireless)',value:'G'},
                                        {label:'رایانکده آپادانا (Wireless)',value:'H'},
                                        {label:'رایانکده آپادانا (Wireless)',value:'K'},
                                        {label:'رایانکده آپادانا (Wireless)',value:'L'},
                                    ]}

                                    styleRoot={{
                                        width: '100%'
                                    }}
                                />*/}
                                            </TouchableOpacity>
                                                {
                                                    // DataSplashSatiaScreen && DataSplashSatiaScreen.wallet && DataSplashSatiaScreen.wallet >= 0 &&
                                                    // <TouchableOpacity
                                                    //     onPress={() => {
                                                    //         NavigationService.navigateParams("IncreaseCreditSatiaScreen")
                                                    //
                                                    //     }}
                                                    //     style={{
                                                    //         flexDirection:"row",
                                                    //         alignSelf: 'center',
                                                    //         alignItems: "center",
                                                    //         justifyContent: "center",
                                                    //
                                                    //         //  width: '100%',
                                                    //         height: moderateScale(40),
                                                    //         marginVertical: moderateScale(4),
                                                    //         paddingHorizontal: moderateScale(8),
                                                    //
                                                    //         backgroundColor: Colors.white,
                                                    //         borderRadius: moderateScale(8),
                                                    //         borderColor: Colors.colorSecondPrimary,
                                                    //         borderWidth: moderateScale(1),
                                                    //     }}
                                                    // >
                                                    //     <HMIcon name={"ios-wallet-outline"} style={{
                                                    //         fontSize: moderateScale(20),
                                                    //         color: Colors.colorSecondPrimary,
                                                    //         marginHorizontal:moderateScale(4)
                                                    //     }}/>
                                                    //
                                                    //     <HMTextView
                                                    //         //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    //         cammas
                                                    //         text={"کیف پول شما " + (DataSplashSatiaScreen.wallet / 10) + " تومان است برای افزایش کلیک نمایید"}
                                                    //         type={"bold"}
                                                    //         style={{
                                                    //             textAlign: "center",
                                                    //             color: Colors.blackLight,
                                                    //             fontSize: moderateScale(14)
                                                    //
                                                    //         }}/>
                                                    // </TouchableOpacity>
                                                }
                                            </View>
                                            :
                                            null
                                    }
                                    {/*        {
                                results && results.slider && results.slider != null && results.slider.length > 0 ?
                                    <View style={{
                                        width: '100%',
                                        height: typeExport._WIDTH / (results.slider_height ? results.slider_height : 3),
                                    }}>

                                        <Carousel page

                                                  ref={c => this._slider1Ref = c}
                                            // data={ENTRIES1}
                                                  data={results.slider}
                                            //       data={[
                                            //           {
                                            //               id: '',
                                            //               image: "http://www.satiaisp.com/wp-content/uploads/2019/11/1.jpg",
                                            //           },
                                            //           {
                                            //               id: '',
                                            //               image: "http://www.satiaisp.com/wp-content/uploads/2020/04/adsl1399.jpg",
                                            //           },
                                            //           {
                                            //               id: '',
                                            //               image: "http://www.satiaisp.com/wp-content/uploads/2020/05/620-header.jpg",
                                            //           },
                                            //           {
                                            //               id: '',
                                            //               image: "http://www.satiaisp.com/wp-content/uploads/2019/10/lte-satiaisp3.jpg",
                                            //           },
                                            //           {
                                            //               id: '',
                                            //               image: "http://www.satiaisp.com/wp-content/uploads/2019/11/200000.jpg",
                                            //           },
                                            //           {
                                            //               id: '',
                                            //               image: "http://www.satiaisp.com/wp-content/uploads/2018/07/brand-banner.jpg",
                                            //           },
                                            //
                                            //       ]}
                                            //    data={this.state.entries}
                                                  renderItem={this._renderItemWithParallax}
                                            // inactiveSlideScale={.99}
                                            // sliderWidth={sliderWidth}
                                            // itemWidth={itemWidth}

                                                  inactiveSlideScale={1}
                                                  sliderWidth={sliderWidth}
                                                  itemWidth={itemWidth}
                                                  hasParallaxImages={true}
                                                  firstItem={SLIDER_1_FIRST_ITEM}

                                                  inactiveSlideOpacity={0.7}
                                            // inactiveSlideShift={20}
                                                  containerCustomStyle={styles.slider}
                                                  contentContainerCustomStyle={styles.sliderContentContainer}
                                            // loop={true}
                                            //loopClonesPerSide={1}
                                                  autoplay={true}
                                                  autoplayDelay={1000}
                                                  autoplayInterval={6000}
                                                  onSnapToItem={(index) => this.setState({slider1ActiveSlide: index})}
                                                  removeClippedSubviews={false}
                                        />

                                        <View style={{height: moderateScale(4)}}/>
                                        <Pagination
                                            dotsLength={6}
                                            // dotsLength={results.slider.length}
                                            activeDotIndex={slider1ActiveSlide}
                                            containerStyle={styles.paginationContainer}
                                            //  dotColor={'rgba(255, 255, 255, 0.92)'}
                                            dotColor={Colors.colorSecondPrimary}
                                            dotStyle={styles.paginationDot}
                                            inactiveDotColor={Colors.black}
                                            inactiveDotOpacity={0.4}
                                            inactiveDotScale={0.6}
                                            carouselRef={this._slider1Ref}
                                            tappableDots={!!this._slider1Ref}
                                        />
                                    </View>
                                    :
                                    null
                            }*/}

                                    <View
                                        style={{
                                            width: '95%',
                                            // height: typeExport._WIDTH / 2.8,
                                            //  backgroundColor: '#d62aee',

                                            alignSelf: 'center',
                                            // padding:moderateScale(1),
                                            borderWidth: moderateScale(1),
                                            borderRadius: moderateScale(2),
                                            borderColor: '#ddd',
                                            borderBottomWidth: 0,
                                            shadowColor: '#000',
                                            shadowOffset: {width: 0, height: moderateScale(1)},
                                            shadowOpacity: 0.6,
                                            shadowRadius: moderateScale(2),
                                            elevation: moderateScale(1),
                                            marginLeft: moderateScale(5),
                                            marginRight: moderateScale(5),
                                            marginTop: moderateScale(6),
                                            backgroundColor: Colors.white,
                                        }}>


                                        <View
                                            style={{
                                                flexDirection: 'row',
                                                width: "100%",
                                                // marginVertical: moderateScale(4),

                                                backgroundColor: Colors.colorSecondPrimary,

                                            }}>
                                            <View
                                                style={{
                                                    flex: .15,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    backgroundColor: Colors.colorPrimary,
                                                    paddingVertical: moderateScale(8)
                                                }}>
                                                <HMTextView
                                                    type={"bold"}

                                                    style={[
                                                        {
                                                            // position: 'absolute',
                                                            //  bottom: 0,
                                                            // height: moderateScale(44),
                                                            // width: '100%',
                                                            textAlign: "center",
                                                            color: Colors.white,
                                                            fontSize: moderateScale(14),
                                                            //  padding: moderateScale(1),

                                                            // backgroundColor: 'rgba(0,0,0,0.25)',
                                                        }]}
                                                    numberOfLines={2}
                                                    text={i18n.t('constant.Current')}
                                                />
                                            </View>
                                            <View
                                                style={{
                                                    flex: .18,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    flexDirection: "row",
                                                    flexWrap: 'wrap',

                                                    // backgroundColor: Colors.white
                                                }}>
                                                <HMTextView
                                                    type={"bold"}
                                                    style={[
                                                        {
                                                            textAlign: "center",
                                                            color: Colors.white,
                                                            fontSize: moderateScale(13),
                                                            paddingHorizontal: moderateScale(3),
                                                            //    backgroundColor: Colors.green,
                                                        }]}
                                                    numberOfLines={2}
                                                    text={IBSExpire ? IBSExpire : "0"}
                                                />
                                                <HMTextView
                                                    type={"bold"}
                                                    style={[
                                                        {
                                                            textAlign: "center",
                                                            color: Colors.white,
                                                            fontSize: moderateScale(12),
                                                            paddingHorizontal: moderateScale(3),
                                                            //    backgroundColor: Colors.green,
                                                        }]}
                                                    numberOfLines={2}
                                                    text={"روز باقیمانده"}
                                                />
                                            </View>
                                            <View
                                                style={{
                                                    flex: .2,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    flexDirection: "row",
                                                    flexWrap: 'wrap',
                                                    //backgroundColor: Colors.light
                                                }}>
                                                <HMTextView
                                                    type={"bold"}
                                                    style={[
                                                        {
                                                            textAlign: "center",
                                                            color: Colors.white,
                                                            fontSize: moderateScale(13),
                                                            paddingHorizontal: moderateScale(3),
                                                            // backgroundColor: Colors.green,
                                                        }]}
                                                    numberOfLines={2}
                                                    //text={"50"}
                                                    text={IBSCredit ? Math.round((IBSCredit / FupToInternet) * 100) / 100 : "0"}

                                                />
                                                <HMTextView
                                                    type={"bold"}
                                                    style={[
                                                        {
                                                            textAlign: "center",
                                                            color: Colors.white,
                                                            fontSize: moderateScale(12),
                                                            paddingHorizontal: moderateScale(3),
                                                            //    backgroundColor: Colors.green,
                                                        }]}
                                                    numberOfLines={2}
                                                    text={"گیگ بین الملل"}
                                                />
                                            </View>
                                            <View
                                                style={{
                                                    flex: .45,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    //backgroundColor: Colors.white
                                                }}>
                                                <HMTextView
                                                    type={"bold"}
                                                    style={[
                                                        {
                                                            textAlign: "center",
                                                            color: Colors.white,
                                                            fontSize: moderateScale(14),
                                                            paddingHorizontal: moderateScale(3),
                                                            //    backgroundColor: Colors.green,
                                                        }]}
                                                    numberOfLines={3}
                                                    //  text={"نسترن ۴"}
                                                    text={this.state.ServicesA ? this.state.ServicesA.Name : " - "}

                                                />
                                            </View>
                                        </View>
                                        {/*    <View style={{
                                    width: '99%',
                                    height: moderateScale(1),
                                    marginBottom: moderateScale(0),
                                    alignSelf: 'center',
                                    backgroundColor: Colors.graylight
                                }}/>*/}


                                        <View
                                            style={{
                                                flexDirection: 'row',
                                                width: "100%",
                                                marginVertical: moderateScale(4),
                                                paddingVertical: moderateScale(8)

                                                //   backgroundColor: Colors.light
                                            }}>
                                            <View style={{
                                                flex: .15,
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                //    backgroundColor: Colors.light
                                            }}>
                                                <HMTextView
                                                    type={"bold"}

                                                    style={[
                                                        {
                                                            // position: 'absolute',
                                                            //  bottom: 0,
                                                            // height: moderateScale(44),
                                                            // width: '100%',
                                                            textAlign: "center",
                                                            color: Colors.blackLight,
                                                            fontSize: moderateScale(13),

                                                            //  padding: moderateScale(1),

                                                            // backgroundColor: 'rgba(0,0,0,0.25)',
                                                        }]}
                                                    numberOfLines={2}
                                                    text={i18n.t('constant.Reserve')}
                                                />
                                            </View>
                                            <View style={{
                                                flex: .18,
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                // backgroundColor: Colors.white
                                            }}>
                                                <HMTextView
                                                    type={"bold"}
                                                    style={[
                                                        {
                                                            textAlign: "center",
                                                            color: Colors.colorDarkText,
                                                            fontSize: moderateScale(13),
                                                            paddingHorizontal: moderateScale(3),
                                                            // backgroundColor: Colors.green,
                                                        }]}
                                                    numberOfLines={2}
                                                    //text={"0"}
                                                    text={this.state.ServicesReserve ? this.state.ServicesReserve.Duration : "0"}

                                                />
                                            </View>
                                            <View style={{
                                                flex: .2,
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                flexDirection: "row",
                                                flexWrap: 'wrap',
                                                //  backgroundColor: Colors.light
                                            }}>
                                                <HMTextView
                                                    type={"bold"}
                                                    style={[
                                                        {
                                                            textAlign: "center",
                                                            color: Colors.colorDarkText,
                                                            fontSize: moderateScale(13),
                                                            paddingHorizontal: moderateScale(3),
                                                            //backgroundColor: Colors.green,
                                                        }]}
                                                    numberOfLines={2}
                                                    //   text={"10"}
                                                    text={this.state.ServicesReserve ? (Math.round((this.state.ServicesReserve.CreditGig / (FupToInternet ? FupToInternet : 4)) * 100) / 100) : "0"}

                                                />
                                                {
                                                    customer.IBSReserveCredit ?
                                                        <HMTextView
                                                            type={"bold"}
                                                            style={[
                                                                {
                                                                    textAlign: "center",
                                                                    color: Colors.colorDarkText,
                                                                    fontSize: moderateScale(13),
                                                                    paddingHorizontal: moderateScale(3),
                                                                    //backgroundColor: Colors.green,
                                                                }]}
                                                            numberOfLines={1}
                                                            //   text={"10"}
                                                            //text={(customer.IBSReserveCredit?` + ${customer.IBSReserveCredit} مازاد `:"") }
                                                            text={(`+ ${customer.IBSReserveCredit / (FupToInternet ? FupToInternet : 4)}مازاد`)}

                                                        />
                                                        :
                                                        null
                                                }

                                            </View>
                                            <View style={{
                                                flex: .45,
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                //   backgroundColor: Colors.blackLight
                                            }}>
                                                <HMTextView
                                                    type={"bold"}
                                                    style={[
                                                        {
                                                            textAlign: "center",
                                                            color: Colors.colorDarkText,
                                                            fontSize: moderateScale(13),
                                                            paddingHorizontal: moderateScale(3),
                                                            // backgroundColor: Colors.green,

                                                        }]}
                                                    //   numberOfLines={2}
                                                    //  text={item.rezerve ? item.rezerve.service : "فاقد سرویس رزو"}
                                                    text={this.state.ServicesReserve ? this.state.ServicesReserve.Name : "فاقد سرویس رزو"}

                                                />
                                            </View>
                                        </View>
                                        {/*

                                <View style={{
                                    width: '99%',
                                    height: moderateScale(1),
                                    marginBottom: moderateScale(0),
                                    alignSelf: 'center',
                                    backgroundColor: Colors.graylight
                                }}/>
                                <View
                                    style={{
                                        flexDirection: 'row',
                                        flex: 1,
                                        // height:moderateScale(100),
                                        backgroundColor: Colors.white,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                       // paddingVertical: moderateScale(6)
                                    }}>

                                    <TouchableOpacity

                                        onPress={() => {

                                        }}
                                        style={{
                                            //flex: .32,
                                            height: typeExport._WIDTH/12,
                                            width: typeExport._WIDTH/3.2,
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: Colors.yellow,
                                            borderRadius: moderateScale(6)
                                        }}>
                                        <HMTextView
                                            //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                            text={"اعتبار موقت"} type={"bold"}
                                            style={{
                                                fontSize: moderateScale(13),
                                                marginVertical: moderateScale(3),
                                                marginHorizontal: moderateScale(4),
                                                color: Colors.white
                                            }}/>
                                    </TouchableOpacity>
                                    <TouchableOpacity

                                        onPress={() => {

                                        }}
                                        style={{
                                            height: typeExport._WIDTH/12,
                                            width: typeExport._WIDTH/3.2,
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: Colors.green,
                                            borderRadius: moderateScale(6),
                                            marginHorizontal: moderateScale(3)
                                        }}>
                                        <HMTextView
                                            //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                            text={"خرید اعتبار "} type={"bold"}
                                            style={{
                                                fontSize: moderateScale(13),
                                                marginVertical: moderateScale(6),
                                                marginHorizontal: moderateScale(4),
                                                color: Colors.white
                                            }}/>
                                    </TouchableOpacity>
                                    <TouchableOpacity

                                        onPress={() => {

                                        }}
                                        style={{
                                            height: typeExport._WIDTH/12,
                                            width: typeExport._WIDTH/3.2,
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: Colors.red,
                                            borderRadius: moderateScale(3)
                                        }}>
                                        <HMTextView
                                            //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                            text={"تمدید سرویس"} type={"bold"}
                                            style={{
                                                fontSize: moderateScale(13),
                                                marginVertical: moderateScale(6),
                                                marginHorizontal: moderateScale(4),
                                                color: Colors.white
                                            }}/>
                                    </TouchableOpacity>
                                         <HMTextView
                                        type={"bold"}
                                        style={[
                                            {
                                                textAlign: "center",
                                                color: Colors.colorDark,
                                                fontSize: moderateScale(11),
                                            }]}
                                        numberOfLines={2}
                                        //text={"بروزرسانی: 18 اسفند (وزارت بهداشت، درمان و آموزش پزشکی)"}
                                        text={item.desc.find(obj => obj.locale == i18n.locale).title}
                                    />
                                </View>

*/}
                                    </View>

                                    {/*   <View style={{width: "100%",}}>
                                <TouchableOpacity
                                    onPress={() => {
                                        NavigationService.navigateParams("PaySatiaScreen", {
                                            item: this.state.myService

                                            //     {
                                            //     id: 7,
                                            //     name: 'سرویس زنبق یک مگ (یکساله)(240گیگ بین الملل معادل 960 گیگ داخلی )(سطح نقره ای)',
                                            //     image: 'http://partak.satiaisp.com/images/speeds/16384.png',
                                            //     // image_source: PathFile.image.sabt_darkhast,
                                            //     typeClick: 7,
                                            //     duration: "یکساله",
                                            //     Period: "12",
                                            //
                                            //     CostPerMonth: "350,000 ريال",
                                            //     SubscriptionFee: "350,000 ريال",
                                            //     Discount: 0, Tax: "2,000 ریال", subscription: "1,000 ریال",
                                            //     SumPrice: "45,000 ریال",
                                            // }
                                        })

                                    }}
                                    style={{
                                        width: '96%',
                                        height: moderateScale(33),
                                        backgroundColor: Colors.colorSecondPrimary,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        alignSelf: 'center',
                                        flexDirection: 'row',
                                        marginTop: moderateScale(4),
                                        marginHorizontal: moderateScale(4),
                                        borderRadius: moderateScale(8)
                                    }}>

                                    <FontAwesomeIcon name={"loop"}
                                                     style={{
                                                         fontSize: moderateScale(20),
                                                         color: Colors.white,
                                                         textAlign: "center",
                                                         padding: moderateScale(4),

                                                     }}/>
                                    <Image
                                    source={PathFile.image.Check}
                                    //resizeMode="stretch"
                                    style={[{}, {


                                    // position: 'absolute',
                                    //  bottom: 0,
                                    width: moderateScale(15),
                                    height: moderateScale(15),
                                    tintColor: Colors.white
                                    // alignSelf: 'center',
                                    }]}/>
                                    <HMTextView
                                        numberOfLines={1}
                                        type={"bold"}
                                        // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                        text={"تمدید سرویس فعلی"}
                                        style={{
                                            fontSize: moderateScale(12),
                                            color: Colors.white,
                                            marginHorizontal: moderateScale(4)
                                            //  marginTop: moderateScale(4),
                                            //  textAlign: "right",
                                        }}/>

                                    <HMTextView
                                        numberOfLines={1}
                                        type={"bold"}
                                        // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                        //text={`    ${this.state.myService.SumPrice} ریال `}
                                        style={{
                                            fontSize: moderateScale(13),
                                            color: Colors.white,
                                            marginHorizontal: moderateScale(4)
                                            //  marginTop: moderateScale(4),
                                            //  textAlign: "right",
                                        }}/>


                                </TouchableOpacity>
                                                <HMSlider images={typeExport.sliders} autoPlayWithInterval={3000}/>


                                       <View style={{width: '100%', height:typeExport.WIDTH/1.4}}>
                                    <HMSlider images={results.slider}
                                              autoPlayWithInterval={3000}/>
                                </View>

                                   <Carousel
                                        ref={(c) => { this._carousel = c; }}
                                        data={typeExport.ENTRIES1}
                                        renderItem={this._renderItem}
                                        sliderWidth={typeExport.WIDTH-moderateScale(10)}
                                        itemWidth={moderateScale(100)}
                                        layout={'default'}
                                    />
                                <Carousel
                                        ref={c => this._slider1Ref = c}
                                        data={typeExport.ENTRIES1}
                                        renderItem={this._renderItemWithParallax}
                                        sliderWidth={typeExport.WIDTH}
                                        itemWidth={typeExport.WIDTH - moderateScale(50)}
                                        hasParallaxImages={true}
                                        firstItem={1}
                                        inactiveSlideScale={0.94}
                                        inactiveSlideOpacity={0.7}
                                        // inactiveSlideShift={20}
                                        containerCustomStyle={{
                                            marginTop: 15,
                                            overflow: 'visible' // for custom animations
                                        }}
                                        contentContainerCustomStyle={{paddingVertical: 10}}
                                        loop={true}
                                        loopClonesPerSide={2}
                                        autoplay={true}
                                        autoplayDelay={500}
                                        autoplayInterval={3000}
                                        onSnapToItem={(index) => this.setState({slider1ActiveSlide: index})}
                                    />


                            </View>*/}
                                    <HMListDiffSizeSatia
                                        width={this.state.widthOriginal}
                                        myService={this.state.myService}
                                        ServicesReserve={this.state.ServicesReserve}
                                        card={true} title _backgroundColorLoading={Colors.transparent} _main
                                        getTemporaryCredit={this.getTemporaryCredit}
                                        navigation={this.props.navigation}
                                    />
                                </View>
                            </ScrollView>
                            :
                            null
                    }
                    {/*   {1 === 1 ?
                                <HMItemAdvertising
                                    item={{id: '1', image: 'https://simple-ad-exchange.com/images/footer.jpg'}}
                                    onPress={() => {
                                        alert("ookk")
                                    }}/>

                                : null}*/}
                </KeyboardAvoidingView>

                <DialogUpdateAppCustomize/>
                {
                    this.state.isLoading ?
                        <DialogLoadingCustomize/>
                        : null
                }
                {/*   <Toast ref="toast"/>*/}

                {this.renderModal()}
                {/*      <HMBottomSheet
                    ref={(ref) => {
                        this.bottomSheetRef = ref
                    }}
                    index={1}
                    snapPoints={['25%', '50%']}
                    onChange={(index) => {
                        console.log('handleSheetChanges', index);

                    }}
                >
                    <View style={{
                        flex: 1,
                        alignItems: 'center',
                    }}>
                        <Text>Awesome 🎉</Text>
                    </View>
                </HMBottomSheet>*/}

                {/*   <HMBottomSheetModal
                    ref={ref => {
                        this.refRBSheet = ref
                    }}
                    closeOnDragDown={true}
                    closeOnPressMask={false}
                    customStyles={{
                        wrapper: {
                            backgroundColor: "transparent"
                        },
                        draggableIcon: {
                            backgroundColor: "#000"
                        }
                    }}
                >
                    <View style={{width: '100%', height: moderateScale(200), backgroundColor: "#ee0300"}}/>
                </HMBottomSheetModal>*/}
            </View>
        );
    }

    getTemporaryCredit() {

        content.setState({
            //ShowImage:true
            isLoading: true,
            NoInternetDialog: false,

        })


        const formData = new FormData();
        formData.append('lang', i18n.locale);
        formData.append('token', content.props.token);
        formData.append('customer', content.props.DataSplashSatiaScreen.Account ? JSON.stringify(content.props.DataSplashSatiaScreen.Account) : null);


        const config = {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                // "Authorization": `Basic ${params.token}`,
                timeout: typeExport._TIMEOUT_FILE
            }
        };

        axios({
            method: 'post',
            url: typeExport._baseUrlSatia + "ibs/littlemore",
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        //   axios.post(typeExport._baseUrlSatia + "ibs/littlemore", formData, config)
            .then(async response => {
                let data = response.data;
                let list = response.data.result && response.data.result.data ? response.data.result.data : response.data.result;


                // data.status ? this.state.listImage.push(image) : null;
                HMAlert(
                    i18n.t('constant.message'),
                    data.message,
                    [
                        {
                            text: i18n.t('constant.ok'), onPress: () => {

                            }


                        },

                    ],
                    {cancelable: true}
                )
                if (data.status) {
                    content.getDataServerSplash()
                }
                else {

                }
                content.setState({
                    //ShowImage:true
                    //list: data.status ? list : this.state.list,
                    //TypeDocumentsList:[],
                    isLoading: false,
                    NoInternetDialog: !data.status,

                })
            }).catch((e) => {
            HMAlert(
                i18n.t('constant.message'),
                "خطا در ارتباط با سرور لطفا مجددا تلاش نمایید",
                [
                    {
                        text: i18n.t('constant.ok'), onPress: () => {

                        }


                    },

                ],
                {cancelable: true}
            )
            content.setState({
                //ShowImage:true
                isLoading: false,
                NoInternetDialog: true,

            })
            console.log('error', e)
        })
    }


    hiddenModal() {
        this.setState({
                visibleModal: false
            },
            () => {
            })
    }

    renderModal(data) {
        let infoDataSplasSatiahScreen = store.getState().reducerSplashSatiaScreen.results ? store.getState().reducerSplashSatiaScreen.results.info : null
        return (
            <HMModal
                isVisible={this.state.visibleModal}
                //visible={this.state.visibleModal}
                backdropColor={Colors.gray}
                backdropOpacity={0.8}
                animationIn="zoomInDown"
                animationOut="zoomOutUp"
                animationInTiming={600}
                animationOutTiming={600}
                backdropTransitionInTiming={600}
                backdropTransitionOutTiming={600}
                //style={{height: '60%'}}
                onBackdropPress={() => this.hiddenModal()}
                onBackButtonPress={() => this.hiddenModal()}

                animationType="slide"
                // transparent={true}
            >

                <View style={[Platform.OS === 'web' ? {width: "90%",} : {},
                    {

                        padding: moderateScale(16),
                        backgroundColor: Colors.white,
                        border: moderateScale(4),

                    }]}>

                    <ScrollView
                        style={{
                            width: '100%'

                        }}
                        ref={scroll => this._scroll = scroll}
                        keyboardShouldPersistTaps="handled"
                    >
                        <View
                            style={{flex: 1,}}
                        >
                            <HMTextView
                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                text={infoDataSplasSatiahScreen && infoDataSplasSatiahScreen.help && infoDataSplasSatiahScreen.help.title ? infoDataSplasSatiahScreen.help.title : "چند دقیقه فیلم آموزش امکانات"}
                                type={"bold"}
                                style={{
                                    fontSize: moderateScale(16),
                                    marginVertical: moderateScale(2),
                                    marginHorizontal: moderateScale(4),
                                    color: Colors.blackLight,
                                    //    textAlign: "center",
                                }}/>
                            {
                                infoDataSplasSatiahScreen && infoDataSplasSatiahScreen.help && infoDataSplasSatiahScreen.help.description ?
                                    <HMTextView
                                        //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                        text={infoDataSplasSatiahScreen.help.description}
                                        type={"bold"}
                                        style={{
                                            fontSize: moderateScale(13),
                                            marginVertical: moderateScale(6),
                                            // marginHorizontal: moderateScale(4),
                                            color: Colors.colorDarkText,
                                            // textAlign: "center",
                                        }}/>
                                    :
                                    null
                            }


                            <View
                                style={{
                                    flexDirection: 'row', width: '100%', justifyContent: 'space-between',
                                    //  backgroundColor: 'red',
                                    marginTop: moderateScale(10),
                                    marginBottom: moderateScale(4), alignSelf: 'center',
                                }}>
                                <TouchableOpacity
                                    onPress={() => {
                                        Tools.GoLink(infoDataSplasSatiahScreen && infoDataSplasSatiahScreen.help && infoDataSplasSatiahScreen.help.link ? infoDataSplasSatiahScreen.help.link : "https://www.aparat.com/v/MYzB4")
                                    }}
                                    style={{
                                        flex: 1,
                                        // width: '92%',
                                        height: moderateScale(42),
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: Colors.green,
                                        borderRadius: moderateScale(6),


                                    }}>

                                    <HMTextView
                                        //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                        text={"پخش"}
                                        styleRoot={{
                                            flexDirection: 'column',
                                            flex: 1,
                                            // justifyContent: "flex-end",
                                            flexWrap: 'wrap',
                                            alignItems: 'center', justifyContent: 'center'
                                        }}
                                        type={"bold"}
                                        style={{
                                            fontSize: moderateScale(13),
                                            marginVertical: moderateScale(2),
                                            // marginHorizontal: moderateScale(4),
                                            color: Colors.white,
                                            textAlign: 'center',

                                        }}/>
                                </TouchableOpacity>
                                <TouchableOpacity
                                    onPress={() => {
                                        this.hiddenModal()

                                    }}
                                    style={{

                                        flex: 1,
                                        // width: '92%',
                                        //height: moderateScale(42),
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: Colors.yellow,
                                        borderRadius: moderateScale(6),
                                        marginHorizontal: moderateScale(2)


                                    }}>

                                    <HMTextView
                                        //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                        // text={i18n.t('constant.Registration')}
                                        text={"بعدا می بینم"}
                                        styleRoot={{
                                            flexDirection: 'column',
                                            flex: 1,
                                            // justifyContent: "flex-end",
                                            flexWrap: 'wrap',
                                            alignItems: 'center', justifyContent: 'center'

                                        }}
                                        type={"bold"}
                                        style={{
                                            fontSize: moderateScale(13),
                                            marginVertical: moderateScale(2),
                                            //     marginHorizontal: moderateScale(4),
                                            color: Colors.white,

                                            textAlign: 'center',

                                        }}/>

                                </TouchableOpacity>
                                {
                                    this.state.help ?
                                        null
                                        :
                                        <TouchableOpacity
                                            onPress={async () => {
                                                this.hiddenModal()
                                                this.setState({
                                                    help: true,
                                                })
                                                await AsyngStorageClass.setAsyng("_Help", true)
                                            }}
                                            style={{
                                                flex: 1,
                                                // width: '92%',
                                                //   height: moderateScale(80),
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: Colors.red,
                                                borderRadius: moderateScale(6),
                                                flexDirection: 'row',


                                            }}>

                                            <HMTextView
                                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                //   text={"این پیام نمایش داده نشود"}
                                                text={"پیام دیگر نمایش داده نشود"}
                                                type={"bold"}
                                                numberOfLines={2}
                                                styleRoot={{
                                                    flexDirection: 'column',
                                                    flex: 1,
                                                    // justifyContent: "flex-end",
                                                    flexWrap: 'wrap',
                                                    alignItems: 'center', justifyContent: 'center'

                                                }}
                                                style={{
                                                    fontSize: moderateScale(12),
                                                    marginVertical: moderateScale(2),
                                                    //  marginHorizontal: moderateScale(4),
                                                    color: Colors.white,
                                                    textAlign: 'center',
                                                }}/>
                                        </TouchableOpacity>
                                }


                            </View>
                        </View>
                    </ScrollView>
                    {
                        this.props.isLoadingSet ?
                            <DialogLoadingCustomize/>
                            : null
                    }

                </View>
            </HMModal>
        );
    }
}

const styles = StyleSheet.create({
    centeredView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        marginTop: 22
    },
    modalView: {
        margin: 20,
        backgroundColor: "white",
        borderRadius: 20,
        padding: 35,
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 5
    },
    openButton: {
        backgroundColor: "#F194FF",
        borderRadius: 20,
        padding: 10,
        elevation: 2
    },
    textStyle: {
        color: "white",
        fontWeight: "bold",
        textAlign: "center"
    },
    modalText: {
        marginBottom: 15,
        textAlign: "center"
    }
});

const mapStateToProps = state => {
    return {

        Account: state.reducerSplashSatiaScreen.Account,
        token: state.reducerSplashSatiaScreen.token,
        DataSplashSatiaScreen: state.reducerSplashSatiaScreen,

    };
};
const mapDispatchToProps = dispatch => {
    return {
        //  callServiceCommentScreen: (url, params, type, typeConnection, page, item_count, token) => dispatch(callWebserviceComment(url, params, type, typeConnection, page, item_count, token)),
        //   callServiceRtl: (data) => dispatch(serviceActionRtl(data)),

    }
};
export default connect(mapStateToProps, mapDispatchToProps)(MainSatiaScreen);
